export default (function applyWindowOffsets(eventGroup, win, type = "add") {
  eventGroup.events.forEach((event, index, events) => {
    if (type === "subtract") {} else {}
  });
  return eventGroup;
});